const deliveryTypes = {
  mail: 'mail',
  email: 'email',
}


export default deliveryTypes
